import { queryParamsStringify } from './query-params-stringify';
import { Params } from '@angular/router';

export const appendQueryParams = (url: string, queryParams: Params) => {
  return `${url}?${queryParamsStringify(queryParams)}`;
};
